<template>
  <div id="app">
    <!-- <div :style="{height: (screenHeight - 50) + 'px'}"> -->
    <div id="nav" :class="{ 'nav_bj': $route.meta.issearch }" v-if="!$route.meta.isNav">
      <!-- <div id="fsb_container" class="tip_title" v-show="!$route.meta.navHide">
        <van-image
          height="39"
          fit="contain"
          lazy-load
          src="https://www.jqxtech.com/static/index/default/images/top_1.png"
        />
      </div> -->
      <div style="position: relative;min-height: 70px;display: flex;align-items: center;justify-content: center;">
        <div class="menu_one" >
          <!-- <div class="menu_list fl" v-if="this.$route.path!='/'" @click="goBack()"> -->
            <!-- <span class="iconfont icon-weibiaoti15"></span> -->
            
          <!-- </div> -->
          <img src="./images/index_tab.png" style="width: 24px;height: 24px;margin-left: 30px;" @click="listto()"/>
          <!-- 添加弹出菜单 -->
          <div class="popup-menu" v-if="showMenu">
            <div class="menu-content">
              <div class="menu-header">
                <div class="close-btn" @click="showMenu = false">×</div>
              </div>
              <div class="menu-list">
                <div 
                  class="menu-item" 
                  v-for="(item, index) in menuItems" 
                  :key="index" 
                  @click="handleMenuClick(item)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <!-- <van-popup class="menu_wrap" v-model="menushow" position="left" closeable
                           :style="{ height: '100%',width: '80%' }">
                    <div class="menu_name" @click="showPopup">
                        <router-link to="/Personal">分类</router-link>
                    </div>
                    <div class="menu">
                        <van-collapse v-model="active1" accordion>
                            <div v-for="(value,index) in nav_header" :key="index">
                                <div v-if="(value.data_type == 'system' && value.name == 'Home')" @click="goHome"><h2>
                                    {{ value.name }}</h2></div>
                                <h2 v-if="!(value.data_type == 'system' && value.name == 'Home')"
                                    @click="toCategory(value.value)">{{ value.name }} </h2>
                                    <div @click="toCategory(value2.value)" v-for="(value2,index2) in value.items"
                                         :key="'2'+index2">
                                        <div class="menu_nr" @click="showPopup">{{ value2.name }}
                                            <van-icon class="nr_icon" name="arrow"/>
                                        </div>
                                    </div>
                            </div>
                        </van-collapse>
                    </div>
                </van-popup> -->
          <!-- <div class="menu_list fl " @click="change">
                    <span class="iconfont icon-sousuo"></span>
                </div> -->
        </div>
        <div @click="showMenu=false" style="position: absolute;left: 50%;transform: translateX(-50%);">
          <router-link  to="/" class="f-clearfix">
            <img
              style="height:52px;"
              fit="contain"
              src="./images/denglu.png"
            />
          </router-link>
        </div>
        <!-- 右侧两个图片 -->
        <div style="display: flex;gap: 15px;margin-left: auto; transform: translate(-15px, 0px);">
          <div class="cart-icon" @click="gocart()">
            <img src="./images/index_shop.png" style="width: 24px;height: 24px;margin-left:-20%" />
            <span class="flex-center" id="cart_total">{{ cart_total }}</span>
          </div>
          <img src="./images/index_mine.png" style="width: 24px;height: 24px;" @click="gomine()"/>
        </div>
        <!-- <router-link to="/personal">
          <div class="menu_list menu_wode">
            <span class="iconfont icon-wode"></span>
          </div>
        </router-link> -->
        <!-- <transition name="van-slide-down"> -->

        <!-- </transition> -->
      
      </div>
      <!-- <div class="nav_search" v-if="$route.meta.issearch">
            <form action="">
                <van-search v-model="value1" show-action placeholder="请输入商品名称搜索.." background="none">
                    <template #action>
                        <div style="transform: translateY(-3px);">
                            <van-button type="primary" size="small" @click="search" color="#000000">搜索</van-button>
                        </div>
                    </template>
                </van-search>
            </form>
        </div> -->
    </div>
    <!-- <div
      class="fixed-carts"
      id="cart_box"
      @mousedown="down"
      @touchstart="down"
      @mousemove="move"
      @touchmove.prevent="move"
      @mouseup="end"
      @touchend="end"
      ref="cart_box"
      v-show="!$route.meta.navHide"
    >
      <router-link to="/carts">
        <van-icon name="shopping-cart-o" color="#fff" />
        <span class="flex-center" id="cart_total">{{ cart_total }}</span>
      </router-link>
    </div>
    <img  class="kefu" @click="openKefu" src="../src/images/kefu_1.png" alt="" /> -->
    <!-- <div class="register_box">
      <van-popup v-model="reward">
        <div @click="closeCouponDiv">
          <van-image
            width="100%"
            lazy-load
            src="https://www.jqxtech.com/static/index/default/images/newyouh.gif"
          />
        </div>
        <van-icon
          name="close"
          color="#fff"
          size="25"
          style="margin-top: 10px"
          @click="closeCouponDiv"
        />
      </van-popup>
    </div> -->
    <div class="youcts">
      <img @click="tolujin('客服')" class="youctsimg" src="./images/kefus.png"  mode="" alt="">
      <img @click="tolujin('售后')" class="youctsimg youctsimg1" src="./images/shous.png"  mode="" alt="">
    </div>
      <router-view />

  </div>
</template>

<style scoped>
.youcts{
  /* width: 60px; */
  /* height: 70px; */
  position: fixed;
  right: 20px;
  top: 60%;
  z-index: 99;
  display: flex;
  flex-direction: column;
}
.youctsimg{
  width: 51px;
}
.youctsimg1{
  margin-top: 20px;
}
.register_box .van-popup {
  width: 70%;
  background-color: transparent;
  line-height: 0;
}

.register_box .van-popup a {
  display: block;
}
.tip_title {
  width: 100%;
  text-align: center;
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  background-color: #fff;
  color: #f73284;
  font-size: 21px;
  font-family: Carter One;
  font-weight: 600;
}
.active2{
  color: #1989fa;
  background-color: #fff;
}

/* 修改购物车数量样式 */
.cart-icon {
  position: relative;
  cursor: pointer;
}

.flex-center {
  position: absolute;
  top: -5px;  /* 调整位置更靠近图标 */
  right: -5px;
  min-width: 14px;  /* 减小最小宽度 */
  height: 14px;  /* 减小高度 */
  line-height: 14px;
  text-align: center;
  background: #DD8560;
  color: #fff;
  border-radius: 50%;  /* 改为圆形 */
  font-size: 10px;  /* 减小字体大小 */
  padding: 0;  /* 移除内边距 */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;  /* 确保始终显示 */
  transition: opacity 0.3s;  /* 添加过渡效果 */
}

#cart_total {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;  /* 固定宽度使其保持圆形 */
  height: 14px;
  visibility: visible !important;  /* 确保始终可见 */
}
</style>

<script>
export default {
  data() {
    return {
      showMenu: false,
      menuItems: [],
      categoryData: [],
      menushow: false,
      value1: "",
      show1: false,
      active1: "",
      nav_header: [],
      cart_total: 0,
      flags: false,
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",
      reward: false,
      screenHeight: window.innerHeight
    };
  },
  created() {
    this.getNav();
    this.getCategoryList();
    this.menushow = false;
    var show_coupon_div = window.localStorage.getItem("showCouponDiv");
    var user_info = this.getUserInfo();
    if (show_coupon_div !== "true" && user_info === false) {
      this.reward = true;
    } else {
      this.reward = false;
    }
    this.initCartTotal();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    tolujin(e){
      let url='https://kf.renguokeji.com/kefu/?app=lishun&amp;extra=eyJpZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwidXNlcl9pZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwiZGV2aWNlX2lkIjoiOWMyMDdiOTVjYWE5ZTNlYTY2ZWViYjFmM2Y0OTRmMTciLCJwbGF0Zm9ybSI6ImFuZHJvaW'
      if(e=='客服'){
        window.open(url)
      }else{
        this.$router.push('/xiangxiwt')
      }
    },
    getCategoryList() {
      const url = "api/search/index";
      const data = {
        category_id: 0,
        keywords: '',
        page: 1
      };
      
      console.log('获取分类列表 - 请求参数:', data);
      
      this.POST(url, data, (ret) => {
        if (ret.code === 0 && ret.data.category && ret.data.category.length > 0) {
          // 存储完整的分类数据
          this.categoryData = ret.data.category;
          
          // 添加"全部"作为第一个选项
          this.menuItems = ['全部'];
          
          // 添加其他分类
          ret.data.category.forEach(item => {
            if (item.text) {
              this.menuItems.push(item.text);
            }
          });
          
          console.log('菜单项更新:', this.menuItems);
        } else {
          // 如果接口失败，使用默认菜单项
          this.menuItems = ['全部', '连衣裙', 'T恤', '针织', '裤子', '衬衫', '半身裙', '外套'];
          console.error('获取分类列表失败，使用默认值');
        }
      });
    },
    handleMenuClick(item) {
      this.showMenu = false;
      
      if (item === '全部') {
        // "全部"选项显示所有数据
        this.$router.push({
          path: '/isedit',
          query: { 
            keywords: '',  // 清空关键词
            showAll: true  // 显示所有商品
          }
        });
      } else {
        // 其他分类使用类别名称作为关键词
        this.$router.push({
          path: '/isedit',
          query: { 
            keywords: item  // 使用菜单项名称作为关键词
          }
        });
      }
    },
    listto(){
      this.showMenu = true;
    },
    gomine() {
    // 使用路由导航到个人详情页面
    this.showMenu=false
    this.$router.push('/Personal')
  },
  gocart() {
    this.showMenu=false
    this.initCartTotal();
    this.$router.push('/carts')
  },
    handleResize() {
      this.screenHeight = window.innerHeight;
    },
    goBack() {
        this.$router.back();
    },
    showPopup() {
      this.menushow = !this.menushow;
    },
    hidePopup() {
      this.menushow = false;
    },
    change() {
      this.show1 = !this.show1;
    },
    getNav() {
      var _self = this;
      this.GET("/nav", function (data) {
        if (data.code == 0) {
          window.nav_header = data.data.header;
          _self.nav_header = data.data.header;
          window.nav_footer = data.data.footer;
          
          // 如果有购物车数量数据，则更新
          if (data.data.cart_total !== undefined) {
            _self.updateCartCount(data.data.cart_total);
          } else {
            // 如果没有数量数据，则从购物车接口获取
            _self.initCartTotal();
          }
        }
      });
    },
    // 实现移动端拖拽
    down() {
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.cart_box.offsetLeft;
      this.dy = this.$refs.cart_box.offsetTop;
    },
    move() {
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        this.$refs.cart_box.style.left = this.xPum + "px";
        this.$refs.cart_box.style.top = this.yPum + "px";
        //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        // window.addEventListener("touchmove",function(){
        //     event.preventDefault();
        // },false);
      }
    },
    //鼠标释放时候的函数
    end() {
      this.flags = false;
    },
    toCategory(id) {
      this.menushow = false;
      var _self = this;
      setTimeout(function () {
        _self.$router.push({ path: "/category", query: { id: id } });
      }, 500);
    },
    goHome() {
      this.menushow = false;
      var _self = this;
      setTimeout(function () {
        _self.$router.push("/");
      }, 500);
    },
    toLogin() {
      window.localStorage.setItem("showCouponDiv", true);
      this.reward = false;
      var _self = this;
      setTimeout(function () {
        _self.$router.push("/login");
      }, 500);
    },
    closeCouponDiv() {
      window.localStorage.setItem("showCouponDiv", true);
      this.reward = false;
    },
    openKefu(){
			window.open('https://kf.renguokeji.com/kefu/?app=lishun&amp;extra=eyJpZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwidXNlcl9pZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwiZGV2aWNlX2lkIjoiOWMyMDdiOTVjYWE5ZTNlYTY2ZWViYjFmM2Y0OTRmMTciLCJwbGF0Zm9ybSI6ImFuZHJvaW');
		},
    updateCartCount(count) {
      // 确保count是数字且不小于0
      count = Math.max(0, parseInt(count) || 0);
      
      // 更新数据
      this.cart_total = count;
      
      // 更新DOM
      const cartTotal = document.getElementById("cart_total");
      if (cartTotal) {
        cartTotal.innerText = count.toString();
      }
    },
    initCartTotal() {
      var url = 'api/cart/index';
      this.GET(url, (data) => {
        if (data.code === 0 && data.data.data) {
          // 使用购物车列表长度更新数量
          this.updateCartCount(data.data.data.length);
        }
      });
    }
  },
  watch: {
    '$route': {
      handler(to, from) {
        // 从购物车页面返回或进入购物车页面时更新数量
        if (to.path === '/carts' || (from.path === '/carts' && to.path === '/')) {
          this.initCartTotal();
        }
        if(to.path === '/isedit' || (from.path === '/isedit' && to.path === '/')){
          this.showMenu=false
        }
        // 监听路由变化，关闭菜单
        this.showMenu = false;
      },
      immediate: true
    },
    cart_total: {
      handler(newVal) {
        const cartTotal = document.getElementById("cart_total");
        if (cartTotal && newVal !== undefined) {
          cartTotal.innerText = newVal.toString();
        }
      },
      immediate: true
    }
  }
};
</script>
<style scoped>
      /* pop */
    
      .popup-menu {
        position: fixed;
        top: 70px;
        left: 0;
        width: 100%;
        height: 530px;
        background: white;
        z-index: 1000;
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }
    
    /* 添加滚动容器 */
    .menu-content {
      height: 100%;
      overflow-y: auto;
      padding-bottom: 50px; /* 添加底部内边距 */
    }
    
    .menu-list {
      padding: 10px 0;
      padding-bottom: 70px; /* 确保底部有足够空间 */
    }
    
    .menu-header {
        padding: 10px;
        text-align: right;
    }
    
    .close-btn {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        font-size: 45px;
        color: #333;
        cursor: pointer;
        transform: translate(-14px, 12px);
    }
    
    .menu-item {
        text-align: left;
        padding: 15px 18px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        font-family: Songti SC, Songti SC;
    }
    
    /* 添加全部分类的特殊样式 */
    .menu-item:first-child {
      color: #DD8560;  /* 使用主题色 */
      border-bottom: 1px solid #f5f5f5;  /* 添加分隔线 */
      margin-bottom: 5px;  /* 增加间距 */
    }
    
    .menu-item:active {
        background-color: #f5f5f5;
    }
</style>
